module.exports = __webpack_public_path__ + "assets/img/ch_banner.d45bdb7d.png";